import { Injectable } from "@angular/core";
import { SwPush } from "@angular/service-worker";
import { ActionService } from "./action.service";
import { MessageService } from "src/message/message.service";
import { PopupMessage, PopupMessageType } from "src/message/popup-message";

@Injectable({ providedIn: "root" })
export class PushNotificationService {
  readonly VAPID_PUBLIC_KEY =
    "BKIQOZfmoQxEQnGO8RoteZ65JtGXaV9gKbFx0hrd_gBml0ZIKxLyTcGx8m_XH9UjNHP7_kE0nIPMHEKh3P5wZKQ";

  constructor(
    private swPush: SwPush,
    private dataService: ActionService,
    private message: MessageService,
  ) {}

  async subscribe(): Promise<"okay" | "error" | "device-error"> {
    if (!this.swPush.isEnabled) {
      this.message.sendPopup(
        new PopupMessage(
          "Dieses Gerät unterstützt keine Push-Benachrichtigungen.",
          PopupMessageType.Okay,
          false,
          () => {},
        ),
      );
      return "device-error";
    }

    try {
      const sub = await this.swPush.requestSubscription({
        serverPublicKey: this.VAPID_PUBLIC_KEY,
      });

      await this.dataService.subscribeForPushNotifications(sub);
      return "okay";
    } catch (e) {
      this.message.sendPopup(
        new PopupMessage(
          "Beim Aktivieren der Benachrichtigungen ist ein Fehler aufgetreten. Kontaktieren Sie Ihr Bibliotheks-Team.",
          PopupMessageType.Okay,
          false,
          () => {},
        ),
      );
      return "error";
    }
  }
}
